const priorityBadge = (value) => {

    if (value == null || value === "") {
        return <span className="text-muted">—</span>
    }

    const display = String(value).trim()
    let wrapClass = "table-sb-inactive"
    let dotClass = "dot-icon-inactive"

    switch (display.toLowerCase()) {
        case "low":
            wrapClass = "table-sb-inactive"
            dotClass = "dot-icon-inactive"
            break
        case "medium":
            wrapClass = "table-sb-not-marked"
            dotClass = "dot-icon-not-marked"
            break
        case "high":
            wrapClass = "table-sb-high"
            dotClass = "dot-icon-high"
            break
        case "critical":
            wrapClass = "table-sb-unpaid"
            dotClass = "dot-icon-unpaid"
            break
        default:
            break
    }

    return (
        <span className={`badge rounded-pill px-2 py-1 d-inline-flex align-items-center gap-2 ${wrapClass}`}>
            <span className={`dot-icon rounded-circle ${dotClass}`} />
            {display}
        </span>
    )
}

export default priorityBadge;